//Dashboard
import Dashboard from "../pages/Dashboard/Dashboard";

//Authentication pages
import Login from "src/pages/Authentication/Login/Login";
import Logout from "src/pages/Authentication/Logout";

//CallBrowser

import CustomReport from "src/components/Common/UI/DndTable/CustomReport";

import StackedBarChartDemo from "src/components/Common/UI/Charts/StackedBarChartDemo";
import ChipDemo from "src/components/Common/UI/Chips/ChipDemo";
import Error404 from "src/pages/Utility/Error404";
import Geographicals from "src/pages/Configuration/Parameters/Geographicals/Geographicals";
import Equipment from "src/pages/Configuration/Parameters/Equipment/Equipment";
import ATM from "src/pages/Configuration/Parameters/ATM/ATM";
import Lines from "src/pages/Configuration/Parameters/Lines/Lines";
import Billings from "src/pages/Configuration/Parameters/Billings/Billings";

import Others from "src/pages/Configuration/Parameters/Others/Others";
import EstablishmentsConfiguration from "src/pages/Configuration/UnitConfiguration/EstablishmentsConfiguration";
import DepartmentConfiguration from "src/pages/Configuration/UnitConfiguration/DepartmentConfiguration";
import AtmConfiguration from "src/pages/Configuration/UnitConfiguration/AtmConfiguration";
import UnitsConfiguration from "src/pages/Configuration/UnitConfiguration/UnitsConfiguration";
import LineConfiguration from "src/pages/Configuration/LinesAndNodesConfiguration/LineConfiguration";
import NodeConfiguration from "src/pages/Configuration/LinesAndNodesConfiguration/NodeConfiguration";
import DCompaniesConfiguration from "src/pages/Configuration/UnitConfiguration/DCompaniesConfiguration";
import PhoneCenters from "src/pages/Configuration/Parameters/PhoneCenters/PhoneCenters";
import PhoneCentersConfiguration from "src/pages/Configuration/PhoneCenters/PhoneCentersConfiguration";
import PhoneLineConfiguration from "src/pages/Configuration/LinesAndNodesConfiguration/PhoneLineConfiguration";
import DetailsPage from "src/pages/Configuration/UnitConfiguration/DetailsPage/DetailsPage";
import BillingSummary from "src/pages/Billing/BillingSummary/BillingSummary";
import FileUploadPage from "src/pages/Billing/BillingUpload/FileUploadPage";
import UserInspector from "src/pages/UserInspector/UserInspector";
import About from "src/pages/About/About";

interface RouteProps {
  path: string;
  component: any;
}

const protectedRoutes: Array<RouteProps> = [

  //Custom table
  { path: "/call-browser/custom-report", component: CustomReport },

  //demo pages
  {path:"/demos/chipdemo", component:ChipDemo},
  {path:"/demos/stackedbarchartdemo", component: StackedBarChartDemo},

  // this route should be at the end of all other routes
  { path: "/", component: Dashboard },

  //not found route
  { path: "*", component: Error404 },
  
  //Configuration
  { path: "/configuration/parameters/geographicals", component: Geographicals},
  { path: "/configuration/parameters/equipment", component: Equipment},
  { path: "/configuration/parameters/atm", component: ATM},
  { path: "/configuration/parameters/lines", component: Lines},
  { path: "/configuration/parameters/billings", component: Billings},
  { path: "/configuration/parameters/phonecenters", component: PhoneCenters},
  { path: "/configuration/parameters/others", component: Others},
  { path: "/configuration/linesandnodes/lines", component: LineConfiguration},
  { path: "/configuration/linesandnodes/nodes", component: NodeConfiguration},
  { path: "/configuration/unitconfiguration/establishments", component: EstablishmentsConfiguration},
  { path: "/configuration/unitconfiguration/departments", component: DepartmentConfiguration},
  { path: "/configuration/unitconfiguration/units", component: UnitsConfiguration}, 
  { path: "/configuration/unitconfiguration/atms", component: AtmConfiguration},
  { path: "/configuration/unitconfiguration/dcompanies", component: DCompaniesConfiguration},
  { path: "/configuration/unitconfiguration/detailspage/:unitType/unittype/:unitID/unitid", component: DetailsPage},
  { path: "/configuration/phonecenters", component: PhoneCentersConfiguration},
  { path: "/phone-charges/phone-lines", component: PhoneLineConfiguration},

  //Phone Charges
  { path: "/billing/file-upload", component: FileUploadPage},
  { path: "/billing/summary", component: BillingSummary},

  {path: "/userinspector", component: UserInspector},

  //system
  { path: "/about", component: About },

];

const publicRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },

];

export { protectedRoutes, publicRoutes };
